/**
 * Supplement Facts — variant switcher
 * Toggles modal panels, inline ingredient cards, and trigger button visibility on variant change.
 */
(function () {
  function update() {
    var current = window.globalVariables &&
      window.globalVariables.product &&
      window.globalVariables.product.currentVariant;
    if (!current) return;

    var id = String(current.id);

    // Toggle modal panels
    var panels = document.querySelectorAll('[data-variant-supplement-facts]');
    var hasFacts = false;
    panels.forEach(function (panel) {
      if (panel.getAttribute('data-variant-supplement-facts') === id) {
        panel.classList.add('is-active');
        hasFacts = true;
      } else {
        panel.classList.remove('is-active');
      }
    });

    // Toggle trigger button
    var triggers = document.querySelectorAll('[data-supplement-facts-trigger]');
    triggers.forEach(function (trigger) {
      trigger.style.display = hasFacts ? '' : 'none';
    });

    // Toggle inline supplement facts cards in ingredients section
    var inlineCards = document.querySelectorAll('[data-variant-ing-facts]');
    inlineCards.forEach(function (card) {
      if (card.getAttribute('data-variant-ing-facts') === id) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }

  document.addEventListener('variant:changed', update);
})();
